import { render, staticRenderFns } from "./kpi-rank-brand.vue?vue&type=template&id=205f0bb9&scoped=true"
import script from "./kpi-rank-brand.vue?vue&type=script&lang=js"
export * from "./kpi-rank-brand.vue?vue&type=script&lang=js"
import style0 from "./kpi-rank-brand.vue?vue&type=style&index=0&id=205f0bb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f0bb9",
  null
  
)

export default component.exports